import React  from "react";
import { useSelector } from "react-redux";
import styled from '@emotion/styled';
import VideoThumbnails from "../helpers/video-thumbnails";

const Hrule = styled.hr`
  margin-top: 10px;
  margin-bottom: 20px;
`

const AlertContainer = styled.div`
  background: #D7F9D7;
  color: #053B05;
  line-height: 16px;
  padding: 12px 16px;
`

const Step10 = () => {
  const { metadata: { pqsResponse } } = useSelector(state => state);

  return (
    <div>
       <AlertContainer>
          <strong>Good News!</strong> Your claim has been established.
       </AlertContainer>
        <p>
          Thank you for submitting your information. Your claim has been established.
          Please check your email for the required next steps.
        </p>
        <Hrule />
          {pqsResponse &&
            <div>
              <h4>Claim #{pqsResponse?.claim_number}</h4>
              <p>{pqsResponse?.street_1} {pqsResponse?.city}, {pqsResponse?.state_province} {pqsResponse?.postal_code}</p>
              <Hrule />
            </div>
          }
        <p>
          Please make a note of your claim number listed above,
          which will be included in your email for any future correspondence with us.
        </p>
        <p>
          The emaill communication will be sent from <a href="mailto:ocqs@owenscorning.com">ocqs@owenscorning.com.</a>&nbsp;
           If you do not receive an email, check your spam, or trash folder.
        </p>
        <p>
          Now that your claim is submitted, please watch the short video below for an overview of the claims process.
        </p>
        <VideoThumbnails show='claim-overview' mid />
    </div>
  )
}

export default Step10;
